<template>
  <div class="county-info">
    <img class="bg" :src="county && county['地图']" alt="">
    <ul class="turbine-list">
      <li v-for="point in pointList" :key="point.left + point.top" class="turbine"
          :style="{ left: point.left + '%', top: point.top + '%' }">
        <img class="blade autorotation" src="../assets/img/blade.png" alt="">
        <img class="tower" src="../assets/img/tower.png" alt="">
        <css-doodle class="css-doodle" grid="2x2">
          :doodle {
          @size: 50px 50px;
          perspective: 0;
          }
          :container {
          perspective: 30px;
          transform-style: preserve-3d;
          }
          position: absolute;
          top: 0;
          left: 0;
          width: 2px;
          height: 2px;
          border-radius: 50%;
          left: 50%;
          top: 50%;
          background: hsl(@rn(10, 0, 255), @rn(10%, 90%), @rn(90%, 100%));
          transform: scale(@rn(1, 2, 3)) translate3d(@rn(-50, 50, 3)px, @rn(-50, 50, 3)px, @rn(-100, 20)px);
          animation: move @rn(5, 15, 3)s infinite @rn(-20, -10, 3)s linear alternate;
          box-shadow: 0 0 1px #fff, 0 0 5px #fff;
          @keyframes move {
          100% {
          margin-top: 100px;
          }
          }
        </css-doodle>
      </li>
    </ul>
    <!--  项目阶段列表  -->
    <div class="tag-group" v-if="isShowTab">
      <div v-for="item in Object.keys(this.county['风机'])" :key="item" :class="{'is-active': curProjectStage === item }" @click="changeProjectStage(item)">{{ item }}</div>
    </div>
    <HeaderTop :title="'金风科技在秦皇岛-' + county.name + '项目推动情况'"></HeaderTop>
    <TimelineCarousel v-if="timeLineList.length > 0" :items="timeLineList" :maxItemLength="6" position="right" @change="openDialog">
      <template v-slot:item="{ item }">
        <h4 class="title" v-html="item['标题']"></h4>
      </template>
    </TimelineCarousel>
    <el-dialog custom-class="cur-timeline" :visible.sync="dialog.isShow" :modal-append-to-body="false" :align-center="true" :title="curTimeline['标题']">
      <div class="pic-panel cur-timeline">
        <div class="header"></div>
        <div class="body">
          <div class="top">
            <h2 class="title">{{ curTimeline['标题'] }}</h2>
          </div>
          <div class="info" v-html="curTimeline['简介']"></div>
        </div>
      </div>
    </el-dialog>
    <transition name="el-zoom-in-center">
      <div class="pic-panel project-intro" :class="{'bottom': timeLineList.length > 0}" v-show="isShowIntro">
        <h2 class="title">{{ projectIntro['title'] }}</h2>
        <div class="header"></div>
        <div class="body">
          <div class="info" v-html="projectIntro['info']"></div>
        </div>
        <div class="body" v-if="projectIntro['img']">
          <div class="info pic">
            <img v-for="item in projectIntro['img']" :key="item" :src="item" alt="">
          </div>
        </div>
      </div>
      </transition>
    <el-button class="go-back" type="text" @click="goBack">
      <i class="el-icon-back"></i>返回
    </el-button>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'county',

  data () {
    return {
      qinhuangdao: this.$store.state.page.pageConfig['金风科技在秦皇岛'],
      county: this.$store.state.page.curCounty,
      timeline: [],
      curTimeline: {},
      dialog: { // 时间线
        isShow: false,
        title: '',
        timelineIndex: 0
      },
      pointList: [],
      curTurbineType: '陆上',
      curProjectStage: '',
      timeLineList: [],
      projectIntro: {},
      isShowIntro: false
    }
  },
  components: {
    HeaderTop: () => import('/src/components/HeaderTop'),
    TimelineCarousel: () => import('/src/components/TimelineCarousel')
  },
  props: [],
  computed: {
    ...mapState({
      pageConfig: state => state.page.pageConfig,
      curCounty: state => state.page.curCounty
    }),
    cityList () {
      return this.qinhuangdao['城市列表']
    },
    isShowTab () {
      return Object.keys(this.county['风机']).length > 1
    }
  },
  watch: {
    curCounty: {
      handler (val) {
        console.log(val)
        this.county = val
        this.changeProjectStage(Object.keys(this.county['风机'])[0])
        if (this.county['项目简介'] && this.county['项目简介']['title']) {
          this.projectIntro = this.county['项目简介']
          this.isShowIntro = true
        }
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    // debugger
    // if (this.isShowTab) {
    //   this.curProjectStage = Object.keys(this.county['大事记'])[0]
    //   this.timeLineList = this.county['大事记'][this.curProjectStage]
    // } else {
    //   this.timeLineList = this.county['大事记']
    //   this.pointList = this.county['风机']
    // }

  },
  methods: {
    openDialog (item, index) {
      this.curTimeline = item
      this.dialog.timelineIndex = index
      this.dialog.isShow = true
    },
    goBack () {
      this.$store.commit('page/DELETE_CURCOUNTY')
    },
    changeProjectStage (stage) {
      this.curProjectStage = stage
      this.timeLineList = this.county['大事记'][stage]
      this.pointList = this.county['风机'][stage]
      // this.curTimeline = {
      //   '标题': stage,
      //   '简介': this.county['项目简介'][stage]
      // }
      // this.dialog.isShow = true
      this.projectIntro = {
        title: stage,
        info: this.county['项目简介'][stage]
      }
      this.isShowIntro = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~/src/assets/css/common.scss";

.county-info{
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  .bg{
    object-fit: cover;
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
  }
  .el-timeline{

  }
}

.haishangdengludian{
  position: fixed;
  left: 45.5%;
  top: 60%;
  z-index: 11;
  width: 337px;
  height: 341px;
  //background: url("../assets/img/haishang-dengludian.png") no-repeat center / cover;
  .turbine{
    left: unset;
    right: 111px;
    bottom: 120px;
  }
}

.el-dialog.project-intro{
  left: 100%;
  transform: translate(-100%, -50%);
}
.project-intro{
  position: fixed;
  top: 50%;
  right: 60px;
  width: 620px;
  transform: translate(0, -50%);
  z-index: 10;
  &.bottom{
    width: 500px;
    right: 350px;
    top: unset;
    bottom: 10px;
    transform: unset;
  }
  .title {
    position: absolute;
    top: -30px;
    left: 0;
    background: url("../../src/assets/img/icon-panel-title.png") no-repeat -2px center / 22px;
    padding-left: 20px;
    font-size: 20px;
    margin-bottom: 10px;
    color: #fff;
    font-size: 24px;

  }
  .body{
    background: rgba(0,61,114,0.59);
    border-radius: 4px;
    border: 2px solid;
    border-image: linear-gradient(133deg, rgba(0, 101, 255, 0), rgba(72, 150, 255, 1), rgba(0, 48, 255, 0)) 2 2;
    backdrop-filter: blur(4px);
    &+.body{
      margin-top: 10px;
    }
    .info{
      padding: 30px 40px;
      font-size: 14px;
      background-color: transparent;
      text-indent: 2em;
    }
  }
  .pic{
    display: flex;
    img{
      flex: 1;
      width: 50%;
      max-height: 20vh;
      object-fit: contain;
    }
  }
}
</style>
